<template>
  <embedded-crud-table
    :allow-actions="allowActions"
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :generate-summary="generateSummary"
    :caption="caption"
    :disabled="disabled"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :permission-code="permissionCode"
    :tabbed="tabbed"
    :definition="{}"
    :editor-is-popup="editorIsPopup"
    :on-create="handleCreate"
    :on-edit="handleEdit"
    :on-table-row-double-click="onRowDoubleClick"
    :show-edit="() => {}"
    :show-create="() => {}"
    enable-save-and-next="false"
    :parent-id-filter-field="parentIdFilterField"
    :disable-filtering="true"
    :disable-sorting="true"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import formMixin from './form-mixin';
import baseCrudMixin from '@/mixins/crud';

const Labels = {
  Yes: 'common.yes',
  No: 'common.no'
};

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [formMixin, baseCrudMixin],
  props: {
    caption: String,
    parentIdFilterField: {
      type: String,
      required: true
    },
    permissionCode: String,
    disabled: {
      default: false,
      type: Boolean
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    allowActions: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    },
    tabbed: {
      default: true,
      type: Boolean
    },
    parentID: Number,
    editorIsPopup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns: [
        { field: 'productGroupDescription', label: 'productGroup.description' },
        { field: 'activeYN', label: 'productGroup.active', formatter: this.formatBool },
        { field: 'parcelTypeDescription', label: 'productGroup.parcelType' },
        { field: 'sideFinishDescription', label: 'common.defaultSideFinishID' },
        { field: 'defaultSideFinishMeasurementInCm', label: 'common.defaultSideFinishMeasurementInCm' },
        { field: 'bottomFinishDescription', label: 'common.defaultBottomFinishID' },
        { field: 'defaultBottomFinishMeasurementInCm', label: 'common.defaultBottomFinishMeasurementInCm' },
        { field: 'defaultLiningBottomFinishDescription', label: 'common.defaultLiningBottomFinishID' },
        { field: 'defaultLiningBottomFinishMeasurementInCm', label: 'common.defaultLiningBottomFinishMeasurementInCm' },
        { field: 'defaultWeightsYN', label: 'productGroup.addWeights', formatter: this.formatBool }
      ]
    };
  },
  methods: {
    formatBool(row, column, cellValue) {
      return cellValue ? this.$t(Labels.Yes) : this.$t(Labels.No);
    },
    generateSummary(row) {
      const summary = `${row.productGroupDescription}`;
      return summary;
    },
    onRowDoubleClick(row) {
      if (row.id === 0) {
        this.handleCreate(row);
      } else {
        this.handleEdit(row);
      }
    },
    handleCreate(row) {
      const location = {
        name: 'Create' + this.entity,
        params: {
          domainID: +this.$route.params.id,
          productGroupID: row.productGroupID,
          description: row.productGroupDescription
        }
      };
      this.$router.push(location);
      this.$emit('create');
    },
    handleEdit(row) {
      const { id } = row;
      const location = {
        name: 'Edit' + this.entity,
        params: {
          domainID: +this.$route.params.id,
          productGroupID: row.productGroupID,
          description: row.productGroupDescription
        }
      };
      this.$router.push(location);
      this.$emit('edit', id);
    }
  }
};
</script>

<style lang="scss" scoped></style>
